import { Link } from 'react-router-dom';

// One button, four variants + sizes, mapped onto the existing .btn-* design
// tokens so the whole site stops hand-rolling divergent button styles.
// Renders <Link> (to), <a> (href), or <button> automatically.
const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  success: 'btn-success',
  outline: 'btn-outline',
};

const SIZES = {
  sm: 'text-sm px-4 py-2',
  md: '', // the .btn-* classes already carry px-6 py-3
  lg: 'text-lg px-8 py-4',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  children,
  ...props
}) {
  const classes = `${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || ''} inline-flex items-center justify-center gap-2 ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
